// Varmuuskopion tilarivi (Passi → Ylläpito). Palvelin (backend/app/autobackup.py, `status`) kertoo tilan;
// tässä se muotoillaan lyhyeksi suomenkieliseksi riviksi ja sävyksi. Sävy "warn" nostaa varoituksen esiin.

const fiDate = (iso) => {
  // "2026-10-12" -> "12.10.2026"; muu muoto näytetään sellaisenaan.
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso ?? "");
  return m ? `${Number(m[3])}.${Number(m[2])}.${m[1]}` : String(iso ?? "");
};

/** Kopion ikä ihmisen luettavana: "alle tunti sitten", "5 h sitten", "3 vrk sitten". */
export function ageText(hours) {
  if (hours == null || Number.isNaN(hours)) return "";
  if (hours < 1) return "alle tunti sitten";
  if (hours < 48) return `${Math.round(hours)} h sitten`;
  return `${Math.floor(hours / 24)} vrk sitten`;
}

/** Tiedoston koko: "1,2 Mt", "340 kt". */
export function sizeText(bytes) {
  if (!bytes) return "";
  if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toLocaleString("fi-FI", { maximumFractionDigits: 1 })} Mt`;
  return `${Math.max(1, Math.round(bytes / 1024)).toLocaleString("fi-FI")} kt`;
}

/**
 * Tilarivi: { tone: "ok" | "warn" | "info", title, detail }.
 * Virhe ja myöhässä oleva kopio ovat varoituksia; pois päältä oleva kopiointi on tieto, koska se voi olla tarkoituskin.
 */
export function backupLine(status) {
  if (!status || !status.state) return { tone: "info", title: "Varmuuskopion tila ei ole tiedossa", detail: "" };
  const last = status.last_day ? `Uusin kopio ${fiDate(status.last_day)} (${ageText(status.age_hours)})` : "";
  const more = [status.count ? `${status.count} / ${status.keep} säilössä` : "", sizeText(status.size_bytes)].filter(Boolean).join(", ");
  switch (status.state) {
    case "ok":
      return { tone: "ok", title: "Varmuuskopiointi toimii", detail: [last, more].filter(Boolean).join(". ") };
    case "stale":
      return { tone: "warn", title: "Varmuuskopio on myöhässä", detail: `${last}. Tarkista palvelimen levytila ja loki (docker compose logs).` };
    case "error":
      return { tone: "warn", title: "Varmuuskopiointi epäonnistui", detail: [last, `Virhe: ${status.error}`, "Katso palvelimen loki (docker compose logs)."].filter(Boolean).join(". ") };
    case "none":
      return { tone: "info", title: "Ensimmäistä varmuuskopiota ei ole vielä tehty", detail: "Palvelin tekee sen tunnin sisällä käynnistyksestä." };
    case "off":
      return { tone: "info", title: "Automaattinen varmuuskopiointi ei ole käytössä", detail: "Aseta TILEHUNT_BACKUP_DIR palvelimen asetuksiin (Docker-asennuksessa se on valmiina)." };
    default:
      return { tone: "info", title: "Varmuuskopion tila ei ole tiedossa", detail: "" };
  }
}

/** Tarvitseeko tila huomiota? Käytetään Passin yläreunan varoitukseen ylläpitäjälle. */
export const needsAttention = (status) => backupLine(status).tone === "warn";
